import { render, staticRenderFns } from "./editInfo.vue?vue&type=template&id=4db970de&scoped=true&"
import script from "./editInfo.vue?vue&type=script&lang=js&"
export * from "./editInfo.vue?vue&type=script&lang=js&"
import style0 from "./editInfo.vue?vue&type=style&index=0&id=4db970de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db970de",
  null
  
)

export default component.exports